import { type Styles } from '@adornis/ass/style';
import { XButton } from '@adornis/chemistry/elements/components/x-button';
import '@adornis/chemistry/elements/components/x-flex';
import { customElement, property } from 'lit/decorators.js';
import { FPSColors } from '../theme/theme';
import { FPSFontFamily } from './fps-fonts';

/**
 * @element fps-button
 */
@customElement('fps-button')
export class FpsButton extends XButton {
  override styles(): Styles[] {
    return [
      ...super.styles(),
      {
        ':host': {
          border: '2px solid',
          borderColor: FPSColors.pureBlack,
          background: FPSColors.pureBlack,
          color: this.colors.white,
          '#innerwrapper': {
            padding: '10px 20px',
          },
        },
        'fps-text': {
          fontFamily: FPSFontFamily,
          fontWeight: 'bold',
          letterSpacing: '1px',
          fontSize: '14px',
        },
        ':host(:hover)': {
          background: this.colors.white,
          color: FPSColors.pureBlack,
          transition: 'all .3s ease-in-out',
        },
        ':host([selected])': {
          background: this.colors.white,
          color: FPSColors.pureBlack,
          transition: 'all .3s ease-in-out',
        },
      },
      this.mode === 'icon' ? this.stylesModeIcon() : {},
    ];
  }

  @property({ type: Boolean }) selected: boolean = true;

  protected override stylesModeOutline = (): Styles => ({
    ':host': { color: this.colors.white },
  });

  protected override stylesModeIcon = (): Styles => ({
    ':host': {
      background: FPSColors.pureBlack,
      color: this.colors.white,
      borderRadius: '0',
      '#innerwrapper': {
        height: '25px',
        width: '25px',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0',
      },
      '#icon': {
        fontSize: '18px',
      },
      transition: 'background .3s ease-out',
    },
    ':host([active])': {
      background: this.tone ? this.colors.tone[this.tone] : this.ctaColor,
      color: this.tone ? this.colors.on.tone[this.tone] : this.ctaColor,
    },
    ':host(:hover)': {
      background: this.colors.white,
      color: FPSColors.pureBlack,
    },
  });
}
